<div class="container">
  <div class="filters">
    <div class="p-fluid flex">
      <app-fy-calender label="Date Range" [isMandatory]="true" (onChange)="onChangeDates($event)" [style]="{ width: '16rem' }" />
    </div>

    <span class="p-float-label p-input-icon-right">
      <i class="pi pi-times" *ngIf="(searchText || '').length > 0" (click)="onClearSearch()"></i>
      <input
        type="text"
        pInputText
        [(ngModel)]="searchText"
        (blur)="onSearchFilter()"
        (keyup.enter)="onSearchFilter()"
        placeholder="Enter to search"
      />
      <label>Search Notes</label>
    </span>

    <p-button
      [style]="{ height: '100%' }"
      [disabled]="!(isLoading || (fromDate && toDate && !hasDateError))"
      label="Get Release Notes"
      [loading]="isLoading"
      (onClick)="getReleaseNotes()"
    ></p-button>

    <span style="flex: 1"></span>

    <p-button
      [style]="{ height: '100%' }"
      [disabled]="!(isLoadingReport || (fromDate && toDate && !hasDateError))"
      label="Generate HTML Report"
      [loading]="isLoadingReport"
      (onClick)="getReleaseNotes(true)"
    ></p-button>
  </div>

  <div *ngIf="hasDateError">
    <span style="color: red"> Date range should be within 1 year </span>
  </div>

  <div class="data-content col-12 p-0">
    <p-table
      [value]="filteredData"
      dataKey="id"
      styleClass="p-datatable-sm p-datatable-striped"
      [scrollable]="true"
      scrollHeight="500px"
      [resizableColumns]="true"
      [paginator]="true"
      [rows]="50"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[25, 50, 100]"
      responsiveLayout="scroll"
      [loading]="isLoading"
      [scrollable]="true"
      scrollHeight="flex"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn style="width: 5rem"></th>
          <th pResizableColumn pSortableColumn="securityCode">Security Code <p-sortIcon field="securityCode"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="securityName">Security Name <p-sortIcon field="securityName"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="description">Description <p-sortIcon field="description"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="exDate">Ex Date <p-sortIcon field="exDate"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="caId">CA ID <p-sortIcon field="caId"></p-sortIcon></th>
        </tr>
        <tr *ngIf="isLoading">
          <td colspan="6">
            <p-progressBar *ngIf="isLoading" mode="indeterminate"></p-progressBar>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-expanded="expanded">
        <tr>
          <td>
            <button
              type="button"
              pButton
              pRipple
              [pRowToggler]="item"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            ></button>
          </td>
          <td>{{ item.securityCode }}</td>
          <td>{{ item.securityName }}</td>
          <td class="notes-container">
            <app-description-htmlrenderer [html]="item.description"></app-description-htmlrenderer>
          </td>
          <td>{{ item.exDate | appDate }}</td>
          <td>{{ item.caId }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-item>
        <tr>
          <td [attr.colspan]="6">
            <div class="notes-container">
              <div *ngIf="item.notes?.length > 0; else noNotesFound">
                <app-description-htmlrenderer [html]="item.notes"></app-description-htmlrenderer>
              </div>
              <ng-template #noNotesFound> No Notes found </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="6" style="text-align: center" class="text-secondary">No release notes found</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
